import { z } from "zod";

import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";
import type { AchievementType } from "@rosette/ts/src/business/achievement/AchievementType.js";


export const RevokeAchievementRequest = z.object({
    userPublicID: z.string(),
    achievementID: z.string(),
});
export type RevokeAchievementRequest = z.infer<typeof RevokeAchievementRequest>;

export const RevokeAchievementResponse = z.object({
    success: z.boolean(),
});
export type RevokeAchievementResponse = z.infer<typeof RevokeAchievementResponse>;

export async function revokeAchievement(userPublicID: string, achievement: AchievementType): Promise<void> {
    const request: RevokeAchievementRequest = {
        userPublicID,
        achievementID: achievement.getID(),
    };
    const response = await fetchWithThrow("/api/admin/revokeAchievement", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    RevokeAchievementResponse.parse(await response.json());
}
